import { dialApiFetch, isDialApiConfigured } from './client';

export interface TeamMember {
  id: string;
  email: string;
  display_name: string | null;
  mock: boolean;
}

const FALLBACK: TeamMember[] = [
  { id: 'mock-tom', email: 'tom@zanda.com.au', display_name: 'Tom Kerridge (mock)', mock: true },
  { id: 'mock-susan', email: 'susan@zanda.com.au', display_name: 'Susan Patel (mock)', mock: true },
  {
    id: 'mock-greg',
    email: 'greg@zanda.com.au',
    display_name: 'Greg Bartholomew (mock)',
    mock: true,
  },
  {
    id: 'mock-vanessa',
    email: 'vanessa@zanda.com.au',
    display_name: 'Vanessa Reid (mock)',
    mock: true,
  },
];

export async function listTeam(): Promise<TeamMember[]> {
  if (!isDialApiConfigured) return FALLBACK;
  const { rows } = await dialApiFetch<{ rows: TeamMember[] }>('/v1/team');
  return rows;
}
